import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DeviceWizardTypeEnum,
  IPairDevice,
  TDeviceWizardType
} from 'src/app/core/device.utils';
import { MoveNextByMaxLengthDirective } from '../../pipes/move-next-by-max-length.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-pair-device',
    templateUrl: './pair-device.component.html',
    styleUrls: ['./pair-device.component.scss'],
    imports: [ReactiveFormsModule, MoveNextByMaxLengthDirective, TranslatePipe]
})
export class PairDeviceComponent implements OnInit {
  @Input() modalWizard: TDeviceWizardType = DeviceWizardTypeEnum.serial;

  @Output() pairDevice: EventEmitter<IPairDevice> = new EventEmitter();
  @Output() generateSecureCode: EventEmitter<string> = new EventEmitter();

  serialDeviceForm: FormGroup;
  secureCodeForm: FormArray = this.fb.array([]);

  get secureCodeControls() {
    return this.secureCodeForm.controls as FormControl[];
  }

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.serialDeviceForm = this.fb.group({
      serialNumber: ['', [Validators.required]],
      acceptLogoutAfterPair: [false, [Validators.requiredTrue]]
    });
    Array.from(Array(4).keys()).forEach(() => {
      this.secureCodeForm.push(
        this.fb.control('', [Validators.minLength(1), Validators.maxLength(1)])
      );
    });
  }

  onGenerateSecureCode() {
    if (
      this.serialDeviceForm.valid &&
      this.serialDeviceForm?.get('serialNumber')?.value
    ) {
      this.generateSecureCode.emit(
        this.serialDeviceForm!.get('serialNumber')!.value as string
      );
    }
  }

  onPair() {
    let code = '';
    this.secureCodeControls.forEach((c) => (code += c.value));
    this.pairDevice.emit({
      serialNumber: this.serialDeviceForm!.get('serialNumber')!.value as string,
      secureCode: code
    });
  }
}
